import { evaluateHand } from './evaluator.js';
import { RANKS } from './cards.js';

export const PERSONALITIES = [
  { id: 'mara', name: 'Mara Voss', title: 'The Reader', aggression: 0.34, bluff: 0.06, quote: 'Every hand leaves a footprint.' },
  { id: 'mateo', name: 'Mateo Cruz', title: 'The Drifter', aggression: 0.68, bluff: 0.17, quote: 'Fortune likes a moving target.' },
  { id: 'isaiah', name: 'Isaiah Reed', title: 'The Foreman', aggression: 0.49, bluff: 0.11, quote: 'Measure twice. Wager once.' },
  { id: 'mei', name: 'Dr. Mei Lin', title: 'The Physician', aggression: 0.42, bluff: 0.08, quote: 'A pulse tells on a liar.' },
  { id: 'finn', name: 'Finn Callahan', title: 'The Wireman', aggression: 0.74, bluff: 0.2, quote: 'Bad news travels. Good cards wait.' },
  { id: 'eli', name: 'Eli Tallgrass', title: 'The Rancher', aggression: 0.29, bluff: 0.05, quote: 'Patience outlasts weather.' }
];

function rankValue(card) {
  return RANKS.indexOf(card[0]) + 2;
}

function estimateStrength(holeCards, communityCards = []) {
  const available = [...holeCards, ...communityCards];
  if (available.length >= 5) {
    const evaluation = evaluateHand(available);
    const categoryStrength = evaluation.category / 8;
    const primaryRank = (evaluation.tiebreak[0] || 0) / 14;
    return Math.min(1, categoryStrength + primaryRank * 0.07);
  }
  if (holeCards.length !== 2) return 0;
  const ranks = holeCards.map(rankValue).sort((a, b) => b - a);
  const pair = ranks[0] === ranks[1];
  const suited = holeCards[0][1] === holeCards[1][1];
  const gap = ranks[0] - ranks[1];
  if (pair) return 0.28 + ranks[0] / 20;
  return Math.min(0.72,
    ranks[0] / 28 + ranks[1] / 56
    + (suited ? 0.07 : 0)
    + (gap <= 1 ? 0.06 : gap === 2 ? 0.025 : 0)
    - (ranks[0] < 10 && gap > 3 ? 0.08 : 0));
}

const ALL_IN_DEFENSE = {
  BET_PRE: { contest: 0.58, certain: 0.74 },
  BET_FLOP: { contest: 0.175, certain: 0.255 },
  BET_TURN: { contest: 0.18, certain: 0.26 },
  BET_RIVER: { contest: 0.185, certain: 0.265 }
};

function standsAgainstAllIn({ strength, phase, personality, roll }) {
  const profile = ALL_IN_DEFENSE[phase] || ALL_IN_DEFENSE.BET_PRE;
  if (strength >= profile.certain) return true;

  const contest = profile.contest - personality.aggression * 0.035;
  if (strength < contest) return roll < personality.bluff * 0.1;

  const range = Math.max(0.001, profile.certain - contest);
  const confidence = Math.min(1, (strength - contest) / range);
  const standChance = Math.min(0.92, 0.34 + personality.aggression * 0.28 + confidence * 0.24);
  return roll < standChance;
}

export function chooseAction({ seat, legal, phase, communityCards = [], random = Math.random }) {
  if (legal.length === 1) return legal[0];
  const personality = PERSONALITIES[seat.aiIndex];
  const strength = estimateStrength(seat.cards, communityCards);
  const lateStreetLift = phase === 'BET_TURN' ? 0.04 : phase === 'BET_RIVER' ? 0.07 : 0;
  const pressure = strength + personality.aggression * 0.3 + lateStreetLift;
  const roll = random();
  const raise = legal.find(action => action.type === 'RAISE' || action.type === 'BET');
  const check = legal.find(action => action.type === 'CHECK');
  const call = legal.find(action => action.type === 'CALL');
  const fold = legal.find(action => action.type === 'FOLD');
  const allIn = legal.find(action => action.type === 'ALL_IN');
  const facingStackCommitment = Boolean(allIn && (allIn.intent === 'CALL' || (fold && !check && !call && !raise)));
  if (facingStackCommitment) {
    return standsAgainstAllIn({ strength, phase, personality, roll }) ? allIn : fold;
  }
  if (raise && (pressure > 0.55 || roll < personality.bluff)) return raise;
  if (check) return check;
  if (call && (strength >= 0.13 || roll < 0.25 + personality.aggression * 0.3)) return call;
  return fold || call || legal[0];
}
